export enum InviteResponse {
    Accept = 'Accept',
    Reject = 'Reject',
    BlockOrganisation = 'BlockOrganisation',
    BlockUser = 'BlockUser'
}